<template>
    <div class="pie-chart">
        <design-2021-apprentice-timeline-chart-component
            :series="timelineChartData.series"
            :options="timelineChartData.options">
        </design-2021-apprentice-timeline-chart-component>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: 'design-2021-module-show-duration-timeline-chart-component',
    props: {
        dataIn: Array,
    },
    computed: {
        timelineChartData() {
            if (!this.dataIn.length) {
                return {
                    series: [],
                    options: {},
                };
            }

            const labelColors = this.dataIn.map((data) => {
                return data.fillColor;
            });
            return {
                series: [
                    {
                        data: this.dataIn,
                    },
                ],
                options: {
                    chart: {
                        height: 250,
                        type: 'rangeBar',
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            distributed: true,
                            barHeight: '25%',
                            dataLabels: {
                                hideOverflowingLabels: false,
                            },
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val, opts) {
                            var label = opts.w.globals.labels[opts.dataPointIndex];
                            var a = moment(val[0]);
                            var b = moment(val[1]);
                            var diff = b.diff(a, 'days');
                            return label + ': ' + this.$tc('modules.days', diff);
                        },
                        style: {
                            colors: ['#212529'],
                        },
                    },
                    xaxis: {
                        type: 'datetime',
                    },
                    yaxis: {
                        show: false,
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'left',
                    },
                },
            };
        },
    },
};
</script>

<style scoped></style>
